import { render, staticRenderFns } from "./AlertTagsConfigurator.vue?vue&type=template&id=4826dce2&scoped=true&"
import script from "./AlertTagsConfigurator.vue?vue&type=script&lang=js&"
export * from "./AlertTagsConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./AlertTagsConfigurator.vue?vue&type=style&index=0&id=4826dce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4826dce2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4826dce2')) {
      api.createRecord('4826dce2', component.options)
    } else {
      api.reload('4826dce2', component.options)
    }
    module.hot.accept("./AlertTagsConfigurator.vue?vue&type=template&id=4826dce2&scoped=true&", function () {
      api.rerender('4826dce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/AlertTagsConfigurator.vue"
export default component.exports